<div>
  <figure>
    <img [src]="dataSignal().img" [alt]="dataSignal().title" [title]="dataSignal().title" fetchpriority="high" loading="eager" />
    <figcaption>
      <h2 class="title-about-us">{{ dataSignal().title }}</h2>
      <section [innerHTML]="sanitizedContent(dataSignal().description)" class="description-about-us"></section>
    </figcaption>
  </figure>
</div>
